import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "settings-list-panel",
  "aria-labelledby": "users-title"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "settings-section-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "settings-eyebrow" }, "Acessos"),
    /*#__PURE__*/_createElementVNode("h2", { id: "users-title" }, "Usuários do app"),
    /*#__PURE__*/_createElementVNode("p", null, "Veja quem acessa o financeiro e mantenha os dados de contato visíveis.")
  ])
], -1)
const _hoisted_3 = { class: "settings-table-wrap" }
const _hoisted_4 = { class: "settings-data-table" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Usuário"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Telefone"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Status")
  ])
], -1)
const _hoisted_6 = { class: "settings-primary-cell" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "settings-avatar" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-user",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_8 = { class: "settings-mobile-list" }
const _hoisted_9 = { class: "settings-mobile-card__top" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "settings-avatar" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-user",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_11 = { class: "settings-primary-cell" }
const _hoisted_12 = { class: "settings-mobile-card__body" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Telefone:", -1)
const _hoisted_14 = {
  key: 1,
  class: "settings-list-empty"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-users",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "Nenhum usuário cadastrado", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Os usuários já cadastrados nesta conta aparecerão aqui.", -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_ctx.getAllUsersList.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllUsersList, (user) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: user.id || user.email
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, _toDisplayString(user.name || 'Usuário sem nome'), 1),
                          _createElementVNode("span", null, _toDisplayString(user.email || 'Sem e-mail cadastrado'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatPhone(user.phone)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["status-pill", _ctx.isActive(user) ? 'is-active' : 'is-inactive'])
                      }, _toDisplayString(_ctx.isActive(user) ? 'Ativo' : 'Inativo'), 3)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllUsersList, (user) => {
              return (_openBlock(), _createElementBlock("article", {
                key: `mobile-${user.id || user.email}`,
                class: "settings-mobile-card"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(user.name || 'Usuário sem nome'), 1),
                      _createElementVNode("span", null, _toDisplayString(user.email || 'Sem e-mail cadastrado'), 1)
                    ])
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-pill", _ctx.isActive(user) ? 'is-active' : 'is-inactive'])
                  }, _toDisplayString(_ctx.isActive(user) ? 'Ativo' : 'Inativo'), 3)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.formatPhone(user.phone)), 1)
                  ])
                ])
              ]))
            }), 128))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_18))
  ]))
}